import SkyDiver from ':/components/SkyDiver'
import Alpine from 'alpinejs'
import TestimonialsSlider from ':/components/TestimonialsSlider';

if(document.getElementById('banner-plane')) {

  document.addEventListener('DOMContentLoaded', function(event) {
    SkyDiver.preload()
    document.getElementById('banner-plane').classList.add('fly-plane')
  });

  document.getElementById('banner-plane').addEventListener("click", e => {
    e.preventDefault
    SkyDiver.jump(e.pageX, e.pageY)
  })

}

Alpine.data('TestimonialsSlider', TestimonialsSlider)
